import { PfileTypeId } from '@lib2/model/pfile/PFileType';
import { CONTENT_IMAGE_SPECS, type PfileImageSpec } from '@/lib/constants/pfileImage';
import { TITLE_LOGO_H, TITLE_LOGO_W, TitleLogoUtils } from './TitleLogoUtils';

/**
 * The series title-treatment upload (design ADR-0013; copy from jvm
 * notes/biz/kb/kb_artwork_guide_v1.md Part 1, checks from Part 2). A SERIES
 * asset: the shells draw `artwork.logo` only for series items in the hero, so
 * the category page keeps CONTENT_IMAGE_SPECS without it. Lives beside the
 * validator (a feature module) rather than in lib/constants so the constants
 * layer never imports feature code.
 */
export const TITLE_LOGO_IMAGE_SPEC: PfileImageSpec = {
  pfileTypeId: PfileTypeId.TitleLogo,
  deletePfileTypeIds: [PfileTypeId.TitleLogo],
  label: 'Title logo (transparent)',
  recommendedSize: `${TITLE_LOGO_W} x ${TITLE_LOGO_H}`,
  aspectRatio: TITLE_LOGO_W / TITLE_LOGO_H,
  maxFileSizeMb: 5,
  exactSize: { w: TITLE_LOGO_W, h: TITLE_LOGO_H },
  guidance: [
    'Your series title as a designed wordmark. Shown instead of typed text on Home and on the series page.',
    'Light on dark: white or light colors, solid strokes, fill at least 70% of the width.',
  ],
  avoid: 'Avoid: photos or boxes behind the text, taglines, dark or thin lettering.',
  emptyStateHint: 'Optional. Without it we use the typed title.',
  behaviorNote: `Scaled to fit ${TITLE_LOGO_W} x ${TITLE_LOGO_H}; transparent padding is added.`,
  acceptMimeTypes: ['image/png'],
  acceptExtensions: ['.png'],
  acceptLabel: 'PNG with transparency',
  validate: (file, bitmap) =>
    TitleLogoUtils.verdict(
      { w: bitmap.width, h: bitmap.height },
      TitleLogoUtils.statsFromBitmap(bitmap),
      TitleLogoUtils.isPngFile(file),
    ),
  preprocess: (file, bitmap) => TitleLogoUtils.fitPadToPng(file, bitmap),
};

/** The series editor's uploads: the 16:9 poster, then the title logo. */
export const SERIES_IMAGE_SPECS: PfileImageSpec[] = [...CONTENT_IMAGE_SPECS, TITLE_LOGO_IMAGE_SPEC];
